const initState = {
    isLoading: false,
    data: null,
    error: null,
}

export default function BalanceReducer(state = initState, action) {
    switch (action.type) {
        case "GET_BALANCE_LOADING":
            return {
                ...state,
                isLoading: true,
            }
        case "GET_BALANCE_DATA":
            return {
                ...state,
                data: action.payload,
                isLoading: false,
            }
        case "GET_BALANCE_ERROR":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            }
        case "RESET_BALANCE":
            return {
                ...state,
                isLoading: false,
                data: null,
                error: null,
            }
        default:
            return state
    }
}